import axios from '@/clientAPI'
import axiosV3 from '@/clientAPIV3.ts'
import {DonationType} from '@/features/recurring-gift/types'

export const MEMBERSHIP_PLANS_API = {
    getMembershipPlans: async (params: {rookieId: string}): Promise<DonationType[]> => {
        const {data} = await axios.get(`/rookies/${params.rookieId}/packages`)
        return data
    }
}

export const pathMembershipPlan = async ({
    groupId,
    ...body
}: {
    groupId: string
    name: string
    description: string
    fileUploadId?: number
}) => {
    const {data} = await axiosV3.post(`/groups/${groupId}`, body)
    return data
}

export const removeMembershipPlan = async ({groupId}: {groupId: string}) => {
    const {data} = await axiosV3.delete(`/groups/${groupId}`)
    return data
}
